import {
  withTranslation,
} from 'react-i18next';

import RegattaContactsSectionView from './RegattaContactsSectionView';

const TranslatedComponent = withTranslation()(RegattaContactsSectionView);

const Component = TranslatedComponent;

export default Component;
